// @flow
import { SET_COOKIES_HEIGHT } from "./actions"
import type { SetCookiesHeightAction } from "./actions"

export default function CookiesBannerReducer(state: number = 0, action: SetCookiesHeightAction) {
  switch (action.type) {
    case SET_COOKIES_HEIGHT:
      return action.height

    default:
      return state
  }
}
